module.exports = __webpack_public_path__ + "img/logo.065539cb.png";